var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandCircleUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 17.5263 6.47368 22 12 22C17.5263 22 22 17.5263 22 12C22 6.47368 17.5263 2 12 2C6.47368 2 2 6.47368 2 12ZM8 12.9825C8 12.7018 8.10526 12.4561 8.29825 12.2807L11.193 9.38597C11.6316 8.92983 12.3684 8.92983 12.807 9.38597L15.7018 12.2807C15.8947 12.4561 16 12.7018 16 12.9825C16 13.5263 15.5439 13.9825 15 13.9825C14.7193 13.9825 14.4737 13.8772 14.2982 13.6842L12 11.4035L9.70175 13.6842C9.52632 13.8772 9.2807 13.9825 9 13.9825C8.45614 13.9825 8 13.5263 8 12.9825Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCircleUp);
export default __webpack_public_path__ + "static/media/expand_circle_up.efbc74ee.svg";
export { ForwardRef as ReactComponent };